// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3076) return "static/chunks/3076-build-1745475452374-8fd392011333014c.js";
	if (chunkId === 9558) return "static/chunks/9558-build-1745475452374-f38db3a5e8d202db.js";
	if (chunkId === 2502) return "static/chunks/2502-build-1745475452374-8991e9d49fc233be.js";
	if (chunkId === 9575) return "static/chunks/9575-build-1745475452374-adf827b00e7d4a71.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-build-1745475452374." + {"282":"91e35560b52177bc","1598":"f30b0388b762b963","2441":"23acd31d6f8e788e","3870":"56836f4d7b8e6d37","4256":"6f75d44c9fbcc275","5312":"46a1d29f540458c9","5899":"01b9f1a322c57dd8","9272":"b045ca4c0815d936"}[chunkId] + ".js";
};